/**
 * For some reason nx is complaining about importing this enum from the .types.ts file
 * Here it works fine, so I'm going to leave it here for now
 */
export enum StorageKeys {
  AppId = 'axo.cd.application-id',
  Token = 'axo.cd.token',
}
